
export default "/assets/seline.821cac7b.svg"